import { MatDialogConfig } from '@angular/material/dialog';

/** Panel classes for the two account dialogs that open as a card anchored top-right of the
 *  viewport (under the topbar). Breakpoint offsets/sizes live in styles.css under these classes. */
export const PROFILE_DIALOG_PANEL = 'pa-profile-dialog-panel';
export const CONTACT_DIALOG_PANEL = 'pa-contact-dialog-panel';

/**
 * MatDialog config for Profile / Contact: anchored top-right through the dialog's own position
 * strategy instead of an absolutely-positioned card inside the dialog. That old approach left the
 * real dialog a 280x2px box and relied on Material internals (pre-MDC the card was positioned
 * against the overlay wrapper; MDC's position:relative surface broke it — PDT-35726).
 * Every caller that opens these dialogs must use this, so they all render the same.
 */
export function topRightDialogConfig<D = any>(panelClass: string, extra: MatDialogConfig<D> = {}): MatDialogConfig<D> {
  return {
    ...extra,
    panelClass: ['pa-top-right-dialog', panelClass],
    position: { top: '8rem', right: '60px' },
    // Default MDC caps the dialog at 80vw / 560px; the cards size themselves (see component CSS).
    maxWidth: '100vw',
  };
}
